<template>
    <div class="conversation-module-header mb-8">
        <page-hero
            :eyebrow="eyebrow"
            :title="title"
            :subtitle="subtitle"
            class="mb-5"
        >
            <template #actions>
                <slot name="actions" />
            </template>
        </page-hero>

        <conversation-clinic-context
            :owner-id="ownerId"
            :owners="owners"
            :loading="ownerLoading"
            @change-owner="$emit('change-owner', $event)"
        />

        <glass-panel class="conversation-module-nav pa-2" radius="md">
            <div class="conversation-module-nav__links">
                <router-link
                    v-for="item in visibleItems"
                    :key="item.to"
                    :to="withOwner(item.to)"
                    :class="['conversation-module-nav__link', isActive(item.to) && 'is-active']"
                >
                    <v-icon size="18">{{ item.icon }}</v-icon>
                    <span>{{ item.label }}</span>
                </router-link>
            </div>

        </glass-panel>
    </div>
</template>

<script>
import ConversationClinicContext from './ConversationClinicContext.vue'

export default {
    name: 'ConversationModuleHeader',
    components: { ConversationClinicContext },
    props: {
        title: { type: String, required: true },
        subtitle: { type: String, default: '' },
        eyebrow: { type: String, default: 'Qualidade do atendimento' },
        ownerId: { type: String, default: null },
        owners: { type: Array, default: () => [] },
        ownerLoading: { type: Boolean, default: false },
    },
    computed: {
        isAdmin() {
            return this.$store.state.currentUser?.role === 'admin'
        },
        visibleItems() {
            return [
                { label: 'Visão geral', icon: 'mdi-view-dashboard-outline', to: '/atendimentos' },
                { label: 'Conversas', icon: 'mdi-message-text-outline', to: '/atendimentos/conversas' },
                { label: 'Demandas', icon: 'mdi-tag-multiple-outline', to: '/atendimentos/demandas', adminOnly: true },
                { label: 'WhatsApp', icon: 'mdi-whatsapp', to: '/atendimentos/whatsapp' },
            ].filter(item => !item.adminOnly || this.isAdmin)
        },
    },
    methods: {
        withOwner(path) {
            return this.ownerId ? { path, query: { owner: this.ownerId } } : path
        },
        isActive(path) {
            if (path === '/atendimentos') return this.$route.path === path
            return this.$route.path.startsWith(path)
        },
    },
}
</script>

<style scoped>
.conversation-module-nav {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 16px;
}

.conversation-module-nav__links {
    display: flex;
    align-items: center;
    gap: 4px;
    min-width: 0;
}

.conversation-module-nav__link {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 14px;
    border-radius: 12px;
    color: var(--color-on-surface-variant);
    font-size: 13px;
    font-weight: 800;
    text-decoration: none;
    white-space: nowrap;
    transition: 180ms ease;
}

.conversation-module-nav__link:hover,
.conversation-module-nav__link.is-active {
    color: var(--color-primary);
    background: rgba(112, 42, 225, 0.1);
}

@media (max-width: 700px) {
    .conversation-module-nav {
        align-items: stretch;
        flex-direction: column;
    }

    .conversation-module-nav__links {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .conversation-module-nav__link {
        justify-content: center;
        white-space: normal;
        text-align: center;
    }
}
</style>
